import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UsersRoleService {
  userRoleResourse: any = `${environment.url.BASE_URL}dash-view/role`
  userRole:any; 
  mainUrl:any=environment.url.BASE_URL;

  constructor(private http: HttpClient) {}

  getUserRole(){
    this.userRole=sessionStorage.getItem('userlogin')
    let params = new HttpParams().set("role",this.userRole); 
    return this.http.post(this.userRoleResourse , params);
  }

  getChangePassword(data){
    return this.http.post(this.mainUrl + 'account/change-password', data)
  }

  // getTryMeToken() {
  //   let form = new FormData()
  //   form.append('grant_type','client_credentials')
  //   return this.http.post('https://mock.cerebrumx.ai/oauth2/token',form)
  // }
}
